;(function ( $ ) {

    /**
     *  stickyFooter
     *  fixed footer on short pages
     **/

    'use strict';

    // Create the defaults once
    var pluginName = 'stickyFooter';
    var defaults = {};

    // The actual plugin constructor
    function Plugin ( element, options ) {
        this.element = element;
        this.settings = $.extend( {}, defaults, options );
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    // Avoid Plugin.prototype conflicts
    $.extend(Plugin.prototype, {
        init: function () {
            this.checkPageHeight();
            var _this = this;
            $(window).smartresize(function() {
                _this.checkPageHeight();
            });
        },

        checkPageHeight: function() {
            if ($('body').height() < $(window).height()) {
                $('body').find('footer').css({
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    right: 0
                });
            } else {
                // $('body').find('footer').css({
                //     position: 'static'
                // });
            }
        }
    });

    $.fn[ pluginName ] = function ( options ) {
        return this.each(function() {
            if ( !$.data( this, 'plugin_' + pluginName ) ) {
                $.data( this, 'plugin_' + pluginName, new Plugin( this, options ) );
            }
        });
    };
})( jQuery );
